import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accedes al instante desde cualquier dispositivo, sin esperas ni envíos.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí. El proceso de pago está gestionado por Impultienda con cifrado SSL. Tus datos están completamente protegidos.'
}, {
  q: '¿Es un solo pago?',
  a: 'Sí. Un único pago. Sin suscripciones, sin cargos ocultos, sin letra pequeña.'
}, {
  q: '¿Sirve para entrenadores con poca experiencia?',
  a: 'Sí. Las sesiones están explicadas de manera que cualquier persona con conocimientos básicos de baloncesto puede ejecutarlas. Las consignas clave y las señales de éxito hacen que incluso el entrenador con menos experiencia dirija la sesión con confianza total.'
}, {
  q: '¿Puedo comprar solo algunos tomos?',
  a: 'La colección se vende completa porque la progresión pedagógica entre tomos es parte del valor del sistema. Comprar tomos sueltos rompería la coherencia del método.'
}, {
  q: '¿Qué diferencia hay entre la Oferta Base y el Pack Premium?',
  a: 'La Oferta Base incluye los 6 tomos y los 5 bonos. El Pack Premium añade el Cronograma Maestro Anual (qué sesión exacta toca cada día durante toda la temporada) y la Versión Pocket (fichas de consulta rápida optimizadas para el móvil en pista). La diferencia es de solo 6€.'
}, {
  q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
  a: 'El manual incluye señales de avance y variantes por nivel en cada sesión para que puedas adaptar el ejercicio sin cambiar toda la estructura de la clase.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'Todo el material se entrega en PDF de alta calidad, optimizado para imprimir en A4 y para leer en pantalla en tablet o móvil.'
}, {
  q: '¿Tiene garantía de devolución?',
  a: 'Sí. 14 días de garantía total sin preguntas. Si no estás satisfecho por cualquier motivo, te devolvemos el 100% del importe.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-53" data-mp="1xrrpsnetq31m">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-54" data-mp="22pt7p50ijwbi">
        <div className="text-center" data-id="element-55" data-mp="22p1cvweqq2ma">
          <SectionTag icon="❓" data-id="element-56" data-mp="26qmws1pozh5z">Resolvemos tus dudas</SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-57" data-mp="26oiicpu62zrg">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-white/10 bg-bg-secondary" data-id="element-58" data-mp="2gfmvdk0a8ajn" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" aria-expanded={isOpen} data-id="element-59" data-mp="2lh2g1ayjsf1i">
                  <span className="font-heading text-sm font-semibold text-white sm:text-base" data-id="element-60" data-mp="9ququv55ecfv">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-orange transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-61" data-mp="4tkz38uadoov" />
                </button>
                <AnimatePresence initial={false} data-id="element-62" data-mp="sk8ai43euwg6">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-63" data-mp="nr5g5tqt7iyx">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-64" data-mp="1bgqb7b08m6ok">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}